export default [
  {
    path: '/',
    redirect: { name: 'Square' },
    children: [
      {
        path: 'topup',
        name: 'Topup',
        meta: {
          title: '京东购物卡',
          notice: true,
          clsId: 'chongzhi'
        },
        component: () => import('@/views/Topup/index.vue')
      },
      {
        path: 'member/level',
        name: 'MemberLevel',
        meta: {
          title: '会员等级说明',
          clsId: ''
        },
        component: () => import('@/views/MemberLevel/index.vue')
      },
      {
        path: 'topup/result',
        name: 'TopupResult',
        meta: {
          notice: true
        },
        component: () => import('@/views/TopupResult/index.vue')
      },
      {
        path: 'shop/list',
        name: 'ShopList',
        meta: {
          title: '适用店铺'
        },
        component: () => import('@/views/ShopList/index.vue')
      },
      {
        path: 'detail',
        name: 'CardDetail',
        meta: {
          title: '购物卡详情',
          themeReset: true
        },
        component: () => import('@/views/CardDetail/index.vue')
      },
      {
        path: 'assets/detail',
        name: 'AssetsDetail',
        meta: {
          title: '购物卡详情',
          clsId: 'Carddetail',
          themeReset: true
        },
        component: () => import('@/views/AssetsDetail/index.vue')
      },
      {
        path: 'give',
        name: 'CardGive',
        meta: {
          title: '赠送好友',
          themeReset: true
        },
        component: () => import('@/views/CardGive/index.vue')
      },
      {
        path: 'bind',
        name: 'CardBind',
        meta: {
          title: '京东购物卡',
          themeReset: true
        },
        component: () => import('@/views/CardBind/index.vue')
      },
      {
        path: 'square',
        name: 'Square',
        meta: {
          title: '购物卡包',
          clsId: 'GiftcardList',
          themeReset: true,
          notice: true
        },
        component: () => import('@/views/Square/Square.vue')
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        meta: {
          title: '提现申请',
          themeReset: true
        },
        component: () => import('@/views/Withdraw/index.vue')
      },
      {
        path: 'search',
        name: 'ActivitySearch',
        meta: {
          title: '活动搜索',
          themeReset: true
        },
        component: () => import('@/views/ActivitySearch/index.vue')
      },
      {
        path: 'payment',
        name: 'PaymentCode',
        meta: {
          title: '购物卡·付款码',
          themeReset: true,
          preload: {
            images: [
              'https://img10.360buyimg.com/img/jfs/t1/268879/35/7440/967739/6777b0b9Fede9273f/8dfbcffeadc0526a.png',
              'https://img30.360buyimg.com/img/jfs/t1/275913/5/24665/127365/680794c7Fe0350269/c0a39406cad6a69a.png'
            ]
          }
        },
        component: () => import('@/views/PaymentCode/index.vue')
      },
      {
        path: 'actList',
        name: 'ActivityList',
        meta: {
          themeReset: true
        },
        component: () => import('@/views/ActivityList/index.vue')
      },
      {
        path: 'embed/topup',
        name: 'EmbedTopup',
        meta: {
          themeReset: true,
          clsId: 'HalfRecharge'
        },
        component: () => import('@/views/EmbedTopup/index.vue')
      },
      {
        path: 'embed/topup/result',
        name: 'EmbedTopupResult',
        meta: {
          themeReset: true,
          clsId: 'HalfRechargeResult'
        },
        component: () => import('@/views/EmbedTopupResult/index.vue')
      },
      {
        path: 'embed/protocols',
        name: 'EmbedProtocolList',
        meta: {
          title: '协议列表',
          themeReset: true,
          clsId: 'HalfProtocol'
        },
        component: () => import('@/views/EmbedProtocolList/index.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: { name: 'Square' }
  }
]
